/**
 * UangJalanPage — route entry for the Admin Uang Jalan Operational View
 * (ODE-P07-T08). Applies the client-side permission mirror (UX only — the
 * server-side OD-015 `uang_jalan.view` guard on every endpoint remains the
 * authority) and renders the module. Test seams are passed through (no real
 * fetch in tests).
 *
 * Traces to: ODE-PRD-REQ-071, ODE-PRD-REQ-077, ODE-PRD-REQ-090.
 */

import { useAuth } from '../../auth/AuthContext.js';
import { StateView } from '../../components/StateView.js';
import { hasPermission, UANG_JALAN_MODULE } from '../../rbac/catalog.js';
import { UangJalanModule, type UangJalanSeams } from './UangJalanModule.js';

export function UangJalanPage({ seams }: { readonly seams?: UangJalanSeams } = {}): JSX.Element {
  const { session } = useAuth();
  const allowed =
    session !== null && hasPermission(session.staff.roles, UANG_JALAN_MODULE.permission);
  if (!allowed) {
    return (
      <StateView
        state={{
          kind: 'blocked',
          message: `Peran tidak memiliki izin ${UANG_JALAN_MODULE.permission} untuk halaman ini.`,
        }}
      />
    );
  }
  return <UangJalanModule seams={seams ?? {}} />;
}
